import { forwardRef, ReactNode } from 'react';
import styled from 'styled-components';
import { primaryColor, wMedium } from 'Utils/utilsStyle';

const Wrapper = styled.span`
  display: flex;
  align-items: center;
  font-weight: ${wMedium};
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0px;
  color: ${primaryColor};
  cursor: pointer;
  .date-picker-icon{
    margin-right: 6px;
    margin-top: 2px;
  }
  &.disabled {
    pointer-events: none;
    opacity: 0.6;
  }
`;

type CustomInputProps = {
  text: string;
  onClick?: () => void;
  className?: string;
  icon?: ReactNode
};

export const DatePickerCustomInput = forwardRef<HTMLSpanElement, CustomInputProps>(
  ({
    onClick, className, text, icon,
  }, ref) => (
    <Wrapper
      role="button"
      tabIndex={0}
      className={className}
      onClick={onClick}
      onKeyPress={onClick}
      ref={ref}
    >
      {icon && <span className="date-picker-icon">{icon}</span>}
      {text}
    </Wrapper>
  ),
);

DatePickerCustomInput.defaultProps = {
  onClick: () => { },
  className: '',
  icon: null,
};
